import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

interface VoucherOption {
  value: string;
  displayKey: string;
}

@Component({
  selector: 'app-material-select-demo',
  templateUrl: './material-select-demo.component.html',
  styleUrls: ['./material-select-demo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialSelectDemoComponent implements OnInit {
  formGroup: FormGroup<{
    small: FormControl<VoucherOption>;
    smallValue: FormControl<VoucherOption>;
    smallDisabled: FormControl<VoucherOption>;
    smallDisabledValue: FormControl<VoucherOption>;
    smallError: FormControl<VoucherOption>;
    smallFrameless: FormControl<VoucherOption>;
    smallFramelessValue: FormControl<VoucherOption>;
    smallFramelessDisabled: FormControl<VoucherOption>;
    smallFramelessDisabledValue: FormControl<VoucherOption>;
    smallFramelessError: FormControl<VoucherOption>;

    medium: FormControl<VoucherOption>;
    mediumValue: FormControl<VoucherOption>;
    mediumDisabled: FormControl<VoucherOption>;
    mediumDisabledValue: FormControl<VoucherOption>;
    mediumError: FormControl<VoucherOption>;
    mediumFrameless: FormControl<VoucherOption>;
    mediumFramelessValue: FormControl<VoucherOption>;
    mediumFramelessDisabled: FormControl<VoucherOption>;
    mediumFramelessDisabledValue: FormControl<VoucherOption>;
    mediumFramelessError: FormControl<VoucherOption>;

    large: FormControl<VoucherOption>;
    largeValue: FormControl<VoucherOption>;
    largeDisabled: FormControl<VoucherOption>;
    largeDisabledValue: FormControl<VoucherOption>;
    largeError: FormControl<VoucherOption>;
    largeFrameless: FormControl<VoucherOption>;
    largeFramelessValue: FormControl<VoucherOption>;
    largeFramelessDisabled: FormControl<VoucherOption>;
    largeFramelessDisabledValue: FormControl<VoucherOption>;
    largeFramelessError: FormControl<VoucherOption>;
  }>;

  voucherOptions: VoucherOption[] = [
    {
      value: 'Vitodens 300',
      displayKey: 'Vitodens 300',
    },
    {
      value: 'Vitovalor',
      displayKey: 'Vitovalor',
    },
    {
      value: 'LongValue',
      displayKey: 'Example of very very long key in the form field',
    },
  ];

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      small: new FormControl<VoucherOption>(null),
      smallValue: new FormControl<VoucherOption>(this.voucherOptions[0]),
      smallDisabled: new FormControl<VoucherOption>(null),
      smallDisabledValue: new FormControl<VoucherOption>(this.voucherOptions[0]),
      smallError: new FormControl<VoucherOption>(this.voucherOptions[0], [
        Validators.pattern(/^\d+$/),
      ]),
      smallFrameless: new FormControl<VoucherOption>(null),
      smallFramelessValue: new FormControl<VoucherOption>(this.voucherOptions[0]),
      smallFramelessDisabled: new FormControl<VoucherOption>(null),
      smallFramelessDisabledValue: new FormControl<VoucherOption>(this.voucherOptions[0]),
      smallFramelessError: new FormControl<VoucherOption>(this.voucherOptions[0], [
        Validators.pattern(/^\d+$/),
      ]),

      medium: new FormControl<VoucherOption>(null),
      mediumValue: new FormControl<VoucherOption>(this.voucherOptions[0]),
      mediumDisabled: new FormControl<VoucherOption>(null),
      mediumDisabledValue: new FormControl<VoucherOption>(this.voucherOptions[0]),
      mediumError: new FormControl<VoucherOption>(this.voucherOptions[0], [
        Validators.pattern(/^\d+$/),
      ]),
      mediumFrameless: new FormControl<VoucherOption>(null),
      mediumFramelessValue: new FormControl<VoucherOption>(this.voucherOptions[0]),
      mediumFramelessDisabled: new FormControl<VoucherOption>(null),
      mediumFramelessDisabledValue: new FormControl<VoucherOption>(this.voucherOptions[0]),
      mediumFramelessError: new FormControl<VoucherOption>(this.voucherOptions[0], [
        Validators.pattern(/^\d+$/),
      ]),

      large: new FormControl<VoucherOption>(null),
      largeValue: new FormControl<VoucherOption>(this.voucherOptions[0]),
      largeDisabled: new FormControl<VoucherOption>(null),
      largeDisabledValue: new FormControl<VoucherOption>(this.voucherOptions[0]),
      largeError: new FormControl<VoucherOption>(this.voucherOptions[0], [
        Validators.pattern(/^\d+$/),
      ]),
      largeFrameless: new FormControl<VoucherOption>(null),
      largeFramelessValue: new FormControl<VoucherOption>(this.voucherOptions[0]),
      largeFramelessDisabled: new FormControl<VoucherOption>(null),
      largeFramelessDisabledValue: new FormControl<VoucherOption>(this.voucherOptions[0]),
      largeFramelessError: new FormControl<VoucherOption>(this.voucherOptions[0], [
        Validators.pattern(/^\d+$/),
      ]),
    });

    this.formGroup.controls.smallError.setErrors({ pattern: true });
    this.formGroup.controls.smallError.markAsTouched();
    this.formGroup.controls.smallFramelessError.setErrors({ pattern: true });
    this.formGroup.controls.smallFramelessError.markAsTouched();

    this.formGroup.controls.mediumError.setErrors({ pattern: true });
    this.formGroup.controls.mediumError.markAsTouched();
    this.formGroup.controls.mediumFramelessError.setErrors({ pattern: true });
    this.formGroup.controls.mediumFramelessError.markAsTouched();

    this.formGroup.controls.largeError.setErrors({ pattern: true });
    this.formGroup.controls.largeError.markAsTouched();
    this.formGroup.controls.largeFramelessError.setErrors({ pattern: true });
    this.formGroup.controls.largeFramelessError.markAsTouched();
  }
}
